var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2135_55624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69151 8C7.59386 8 7.49869 7.96229 7.43322 7.89334L4.49993 4.80192L1.56663 7.89334C1.47519 7.98974 1.32572 8.02498 1.19254 7.98179C1.05933 7.93851 0.970703 7.82587 0.970703 7.6998V0.300222C0.970703 0.134427 1.12193 0 1.30845 0H7.6914C7.87789 0 8.02915 0.134427 8.02915 0.300222V7.69975C8.02915 7.82582 7.94052 7.93847 7.80732 7.98175C7.76943 7.99404 7.73025 8 7.69151 8ZM4.49993 4.03601C4.59947 4.03601 4.69393 4.07504 4.7581 4.14268L7.35368 6.87813V0.600444H1.6462V6.87813L4.24175 4.14268C4.30592 4.07504 4.40038 4.03601 4.49993 4.03601Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2135_55624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.39519620b0b2be2744ad8b229059ea4b.svg";
export { ForwardRef as ReactComponent };